<template>
  <div class="estim">
    {{ articleWordCount !== 0 ? estimatedReadTime : '...' }} min read
  </div>
</template>

<script lang="ts" setup>
import { useBlogStore } from '@/store/blog.store'
const blogStore = useBlogStore()
const { articleWordCount } = storeToRefs(blogStore)

const estimatedReadTime = computed(() => {
  const avreageWordsPerMinute = 180

  return Math.floor(articleWordCount.value / avreageWordsPerMinute) || 1
})
</script>

<style lang="scss" scoped>
.estim {
  @include paragraph-s;

  color: var(--navy-600);
}
</style>
